import { type JSX } from 'react';
import { Link } from 'react-router-dom';
import { useNavContext } from '../lib/use-nav-context.ts';
import { BrandLogo } from './BrandLogo.tsx';
import { NavList } from './NavList.tsx';

/**
 * Permanent left rail, shown at lg+ (≥1024px) only.
 *
 * Below lg the same model is presented by MobileNavDrawer - including the four
 * context navs (case / practice / profile), which until v7.100
 * lived here alone and so vanished entirely on phones and tablets. Both read
 * useNavContext(), so gating and destinations live in exactly one place.
 *
 * Breakpoint is lg, not md: at 768px a 224px rail eats 29% of the viewport and
 * leaves 544px for content. Tablets reach the same nav through the drawer.
 *
 * Full height, and it OWNS THE BRAND (owner-approved chrome, 2026-08-18) - one
 * structural element, so no header/rail right-angle. Below lg this is
 * display:none and the header carries the brand; never both at once.
 */
export function AppSidebar(): JSX.Element {
  const nav = useNavContext();

  return (
    <nav
      aria-label="Primary"
      data-testid="app-sidebar"
      className="sticky top-0 hidden h-screen w-60 shrink-0 flex-col overflow-y-auto border-r border-border bg-background p-3 lg:flex"
    >
      <Link
        to="/"
        aria-label="HapMetrix home"
        className="mb-5 mt-1 flex items-center rounded-md px-2 py-1"
      >
        <BrandLogo />
      </Link>
      <NavList nav={nav} />
    </nav>
  );
}
